

export default concat;
import packageResult from 'utils/packageResult';
function concat(bundle, options) {
	// This bundle must be self-contained - no imports or exports
	if (bundle.externalModules.length || bundle.entryModule.exports.length) {
		throw new Error('bundle.concat() can only be used with bundles that have no imports/exports (imports: [' + bundle.externalModules.map(function (x) {
			return x.id;
		}).join(', ') + '], exports: [' + bundle.entryModule.exports.join(', ') + '])');
	}

	// TODO test these options
	var intro = 'intro' in options ? options.intro : '(function () { \'use strict\';\n\n';
	var outro = 'outro' in options ? options.outro : '\n\n})();';
	var indent = undefined;

	if (!('indent' in options) || options.indent === true) {
		indent = bundle.body.getIndentString();
	} else {
		indent = options.indent || '';
	}

	bundle.body.trimLines().indent(indent).prepend(intro).append(outro);

	return packageResult(bundle, bundle.body, options, 'toString', true);
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/bundler/builders/concat.js.01-babel.map